import type { NavigationError } from "@angular/router";

/**
 * Chunk file names are hashed per build, so a tab opened before a release still
 * points at chunks the new deployment no longer serves. The first lazy navigation
 * after the release then fails to import its chunk; reloading to the target URL
 * picks up the new build.
 */
const CHUNK_LOAD_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
];

const RELOAD_STORAGE_KEY = "chunkLoadReloadAt";
const RELOAD_GUARD_MS = 10_000;

export function reloadOnChunkLoadError({ error, url }: NavigationError): void {
  if (!isChunkLoadError(error)) return;

  const lastReloadAt = Number(sessionStorage.getItem(RELOAD_STORAGE_KEY));
  if (Date.now() - lastReloadAt < RELOAD_GUARD_MS) return;

  sessionStorage.setItem(RELOAD_STORAGE_KEY, `${Date.now()}`);
  window.location.assign(url);
}

function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);

  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}
